/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderLabelResponse } from './OrderLabelResponse';
import {
    OrderLabelResponseFromJSON,
    OrderLabelResponseFromJSONTyped,
    OrderLabelResponseToJSON,
    OrderLabelResponseToJSONTyped,
} from './OrderLabelResponse';

/**
 * 
 * @export
 * @interface OrderDto
 */
export interface OrderDto {
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    orderTotal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    orderTotalCurrency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    exploitation?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OrderDto
     */
    date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    externalOrderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    categoryName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    categoryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    businessUnitId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    businessUnitName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    rawOrderData?: string | null;
    /**
     * 
     * @type {Array<OrderLabelResponse>}
     * @memberof OrderDto
     */
    labels?: Array<OrderLabelResponse> | null;
}

/**
 * Check if a given object implements the OrderDto interface.
 */
export function instanceOfOrderDto(value: object): value is OrderDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OrderDtoFromJSON(json: any): OrderDto {
    return OrderDtoFromJSONTyped(json, false);
}

export function OrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'orderTotal': json['orderTotal'] == null ? undefined : json['orderTotal'],
        'orderTotalCurrency': json['orderTotalCurrency'] == null ? undefined : json['orderTotalCurrency'],
        'exploitation': json['exploitation'] == null ? undefined : json['exploitation'],
        'description': json['description'] == null ? undefined : json['description'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'externalOrderId': json['externalOrderId'] == null ? undefined : json['externalOrderId'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'businessUnitId': json['businessUnitId'] == null ? undefined : json['businessUnitId'],
        'businessUnitName': json['businessUnitName'] == null ? undefined : json['businessUnitName'],
        'rawOrderData': json['rawOrderData'] == null ? undefined : json['rawOrderData'],
        'labels': json['labels'] == null ? undefined : ((json['labels'] as Array<any>).map(OrderLabelResponseFromJSON)),
    };
}

export function OrderDtoToJSON(json: any): OrderDto {
    return OrderDtoToJSONTyped(json, false);
}

export function OrderDtoToJSONTyped(value?: OrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderTotal': value['orderTotal'],
        'orderTotalCurrency': value['orderTotalCurrency'],
        'exploitation': value['exploitation'],
        'description': value['description'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString(),
        'externalOrderId': value['externalOrderId'],
        'companyId': value['companyId'],
        'companyName': value['companyName'],
        'categoryName': value['categoryName'],
        'categoryId': value['categoryId'],
        'businessUnitId': value['businessUnitId'],
        'businessUnitName': value['businessUnitName'],
        'rawOrderData': value['rawOrderData'],
        'labels': value['labels'] == null ? undefined : ((value['labels'] as Array<any>).map(OrderLabelResponseToJSON)),
    };
}

